module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n5r1r2r-b34c8e93d92dac93f044484fd9998259.svg";